<script setup lang="ts">
import { computed } from "vue"

const props = defineProps({
  icon: { type: String, required: true },
  duotone: { type: Boolean, default: false },
  fixedWidth: { type: Boolean, default: false },
  cursorPointer: { type: Boolean, default: true },
})

const classes = computed(() => {
  const list = ["fa-solid", `fa-${props.icon}`]
  if (props.duotone) list.push("fa-duotone")
  if (props.fixedWidth) list.push("fa-fw")
  if (props.cursorPointer) list.push("cursor-pointer")
  return list.join(" ")
})
</script>

<template>
  <i :class="classes"></i>
</template>

<style scoped></style>
